import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../../shared/services/auth.service';
import { User } from '../../../modules/admin/models/user.model';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-left-nav',
  standalone: false,
  
  templateUrl: './left-nav.component.html',
  styleUrl: './left-nav.component.scss'
})
export class LeftNavComponent  {  
  constructor(protected authService: AuthService) { }  

  get isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

}
